import { SwitchersStateType } from './switchers.reducer';

export const getCurrentSwitcherOption = (state: SwitchersStateType) =>
  state.currentSwitcherOption;
